import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initCauseBridge1upxfqhavblt6 as initCauseBridge } from '../../../../ktor-ktor-utils/io/ktor/util/internal/ExceptionUtils.web.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { CopyableThrowable1mvc99jcyvivf as CopyableThrowable } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Debug.common.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FrameTooBigExceptionClass;
function FrameTooBigException() {
  if (FrameTooBigExceptionClass === VOID) {
    class $ extends Exception() {
      static r5c(frameSize) {
        var $this = this.td();
        captureStack($this, $this.q5c_1);
        $this.p5c_1 = frameSize;
        delete $this.message;
        return $this;
      }
      r() {
        return 'Frame is too big: ' + this.p5c_1.toString();
      }
      c13() {
        // Inline function 'kotlin.also' call
        var this_0 = FrameTooBigException().r5c(this.p5c_1);
        initCauseBridge(this_0, this);
        return this_0;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'FrameTooBigException', VOID, VOID, [CopyableThrowable()]);
    FrameTooBigExceptionClass = $;
  }
  return FrameTooBigExceptionClass;
}
//region block: exports
export {
  FrameTooBigException as FrameTooBigException1rgdafsgu31sm,
};
//endregion

//# sourceMappingURL=FrameTooBigException.mjs.map
